module.exports = __webpack_public_path__ + "static/login.7bad3390.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Nav/imgs/login.png
// module id = 2739
// module chunks = 0